import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinStateApplyCopiedConfig',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    dtwinId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      copyItems: {
        title: 'properties.title',
        key: 'key',
        unit: 'properties.unit',
        faIcon: 'properties.faIcon',
        linkGeoCoordinate: 'properties.linkGeoCoordinate',
        geoCoordinateKey: 'properties.geoCoordinateKey',
        bindingType: 'properties.binding.type',
        valueType: 'properties.valueType',
        visualization: 'properties.visual',
        transformer: 'properties.binding.transformer.script'
      },
      valuesToCopy: {},
      // the v-model for the UI-checkbox
      // needs to be an own model, to react to input-events,
      // otherwise ONLY the title can be clicked but not the checkbox itself....
      areAllItemsSelected: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    copyConfig: function copyConfig() {
      return this.$store.state.app.dtwinStateConfigCopy;
    },
    copyItemsKeys: function copyItemsKeys() {
      // return Object.keys(this.copyItems).filter((k) => {
      //   return this.isDifferentTwin || ['title', 'key'].indexOf(k) < 0;
      // });
      return Object.keys(this.copyItems);
    },
    allItemsSelected: function allItemsSelected() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.areAllItemsSelected = Object.values(this.valuesToCopy).filter(function (v) {
        return !v;
      }).length === 0;
      return this.areAllItemsSelected;
    },
    isDifferentTwin: function isDifferentTwin() {
      if (!this.dtwinId) {
        return;
      }

      return this.dtwinId !== (this.copyConfig || {}).dtwinId;
    }
  }),
  watch: {
    isOpen: function isOpen() {
      this.setup();
    }
  },
  mounted: function mounted() {
    this.setup();
  },
  methods: {
    setup: function setup() {
      var valuesToCopy = {};
      this.copyItemsKeys.forEach(function (k) {
        valuesToCopy[k] = true;
      });
      this.valuesToCopy = valuesToCopy;
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
    },
    toggleAllItems: function toggleAllItems() {
      var _this = this;

      var toggledState = !this.allItemsSelected;
      this.copyItemsKeys.forEach(function (k) {
        _this.valuesToCopy[k] = toggledState;
      });
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
      this.areAllItemsSelected = this.allItemsSelected;
    },
    refresh: function refresh() {
      // to force e.g. the `allItemsSelected` comp-value to be re-calculated, clone the whole shizzle
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
      this.areAllItemsSelected = this.allItemsSelected;
    },
    applyStateConfig: function applyStateConfig() {
      var _this2 = this;

      var pathsToCopy = [];
      this.copyItemsKeys.forEach(function (k) {
        if (_this2.valuesToCopy[k]) {
          pathsToCopy.push(_this2.copyItems[k]);
        }
      });
      this.$emit('apply', pathsToCopy);
    },
    close: function close(errorMessage) {
      this.$emit('close', errorMessage);
    }
  }
};